import React from "react";

const MainHeader = ({ children }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-3 sm:px-6 pb-4">{children}</div>
);

export default MainHeader;
